import { IntlShape } from 'react-intl';

export const getFilterLabels = (intl: IntlShape) => ({
  all: intl.formatMessage({ id: 'all', defaultMessage: 'All' }),
  udr: intl.formatMessage({ id: 'udr', defaultMessage: 'UDR' }),
  textOverlay: intl.formatMessage({
    id: 'textOverlayFilter',
    defaultMessage: 'Text',
  }),
  head: intl.formatMessage({ id: 'head', defaultMessage: 'Head' }),
  laptop: intl.formatMessage({ id: 'laptop', defaultMessage: 'Laptop' }),
  notepad: intl.formatMessage({
    id: 'notepad',
    defaultMessage: 'Notepad (PII)',
  }),
  card: intl.formatMessage({ id: 'card', defaultMessage: 'ID Card (PII)' }),
  // manual: intl.formatMessage({ id: 'manualInterp' }),
  licensePlate: intl.formatMessage({
    id: 'plateOrVehicle',
    defaultMessage: 'Plate / Vehicle',
  }),
  person: intl.formatMessage({ id: 'person', defaultMessage: 'Person' }),
  poim: intl.formatMessage({ id: 'person', defaultMessage: 'Person' }),
});
